import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LegacyRouterLinkDirective } from './legacy-router-link.directive';
import { LegacyRouterLinkActiveDirective } from './legacy-router-link-active.directive';
import { SharedUtilErrorHandlingModule } from '@mode/shared/util-error-handling';

@NgModule({
  imports: [CommonModule, SharedUtilErrorHandlingModule],
  declarations: [LegacyRouterLinkActiveDirective, LegacyRouterLinkDirective],
  providers: [LegacyRouterLinkDirective, [{ provide: Window, useValue: window }]],
  exports: [LegacyRouterLinkActiveDirective, LegacyRouterLinkDirective],
})
export class SharedUtilDomModule {}
